import React from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import { TRAINING_STATUS } from '~/training/types';

export interface ParticipantStatusChipProps {
  status?: TRAINING_STATUS | null;
}

export type ParticipantStatusChipComponent = React.FC<ParticipantStatusChipProps>;

type KnownStatus =
  | TRAINING_STATUS.PENDING
  | TRAINING_STATUS.APPROVE
  | TRAINING_STATUS.REJECT;

const KNOWN_STATUS_VARIANT_CLASS: Record<KnownStatus, string> = {
  [TRAINING_STATUS.PENDING]: classes['1'],
  [TRAINING_STATUS.APPROVE]: classes['2'],
  [TRAINING_STATUS.REJECT]: classes['3'],
};

const isKnownStatus = (status: TRAINING_STATUS): status is KnownStatus =>
  status === TRAINING_STATUS.PENDING ||
  status === TRAINING_STATUS.APPROVE ||
  status === TRAINING_STATUS.REJECT;

const ParticipantStatusChip: ParticipantStatusChipComponent = ({ status }) => {
  const { t } = useTranslation('training');

  if (status === undefined || status === null || status === TRAINING_STATUS.NOTAPPLICABLE) {
    return null;
  }

  const isKnown = isKnownStatus(status);
  const statusLabel = isKnown ? t(`status.${status}`) : String(status);
  const className = isKnown
    ? `${classes['trainee-status']} ${KNOWN_STATUS_VARIANT_CLASS[status]}`
    : classes['trainee-status-unknown'];

  return (
    <span
      role="status"
      aria-label={`${t('statusTitle')}: ${statusLabel}`}
      className={className}
    >
      {statusLabel}
    </span>
  );
};

export default ParticipantStatusChip;
